import { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutSeries = (nameRef, startDateRef, endDateRef, contentRef, totalGtdRef, mainGtdRef, logoFilePath, imgPathList, oldSeedTypeListRef, seedTypeListRef) => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("PUT", `/admin/series/${idx}`, {
            "name": nameRef?.current?.value,
            "start_date": startDateRef?.current?.value,
            "end_date": endDateRef?.current?.value,
            "content": contentRef?.current?.value,
            "total_gtd": totalGtdRef?.current?.value || null,
            "main_gtd": mainGtdRef?.current?.value || null,
            "logo_img": logoFilePath || null,
            "img_list": imgPathList.length > 0 ? imgPathList : null,
            "seed_ticket_list": oldSeedTypeListRef?.current?.map(elem => {
                return {
                    "idx": elem?.id,
                    "name": elem?.value
                }
            }),
            "new_seed_ticket_list": seedTypeListRef?.current.map(elem => elem?.value)
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate(`/series/${idx}/detail`)
                break
            case 400:
                if (fetchResult?.data?.error_code === "name") setAlert("대회 시리즈 이름 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "start_date") setAlert("시작 날짜 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "end_date") setAlert("종료 날짜 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "content") setAlert("본문 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "seed_ticket_list") setAlert("시드권 종류 목록의 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "total_gtd") setAlert("전체 GTD 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "main_gtd") setAlert("메인 이벤트 GTD 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "img_list") setAlert("이미지 목록의 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])


    return [clickEvent]
}

export default usePutSeries